/* global document */

const petitionsCheckbox = document.querySelectorAll('.js-petitions-checkbox');

petitionsCheckbox.forEach((item) => {
	item.addEventListener('click', () => {
		item.blur();
	});
});
